import { Component, OnInit } from '@angular/core';
import { MiraieService } from '../Services/miraie.service';
import { AuthService } from '../Services/auth.service';
import { Logininfo } from '../classes/Loginifo';
import { FormService } from "../Services/form.service";
import { AnalysisService } from '../Services/analysis.service';
import { OutputService } from '../Services/output.service';

@Component({
  selector: 'app-interview-list',
  templateUrl: './interview-list.component.html',
  styleUrls: ['./interview-list.component.css']
})
export class InterviewListComponent implements OnInit {
  logininfo: Logininfo = this.authService.loginID;
  srcurl: string;

  years: number[];
  year: number;
  months: number[] = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  month: number;

  weeks: any[] = [];
  list: any[] = [];
  rank: any[] = [];


  constructor(
    private miraieService: MiraieService,
    public authService: AuthService,
    private analysisService: AnalysisService,
    private fs: FormService,
    private outputService: OutputService,
  ) {
    
    this.years = this.fs.formSetYear(2018);
  }

  ngOnInit() {
    this.srcurl = this.miraieService.srcurl;
    this.year = new Date().getFullYear();
    this.month = new Date().getMonth() + 1;

    this.search();
  }

  // 集計取得
  search() {
    this.weeks = [];
    this.list = [];
    this.rank = [];
  
    this.analysisService.getInterviewList(this.year, this.month)
      .subscribe(result => { 
        this.list = result['list'];
        this.rank = result['ranking'];
        this.weeks = result['weeks']['weeks'];
    });
  }

  // Excel出力
  output() {
    var date = this.year + '-' + this.month;
    
    let res = this.outputService.getInterviewList(this.year, this.month)
    res.subscribe(res => {
      const url = this.srcurl + "output/interview/面談履歴集計_" + date + ".xlsx";
      window.open(url);
    });

  }
}
